<div fxLayout="column" class="neq-dialog">

  <ng-container *ngIf="showResult()">
    <span [innerHTML]="getJobResult()"></span><br/>
    <span>{{ 'msg.user.calculate-batch.result.resume-success' | translate : { nbSuccess: jobResult.countSuccess, total: jobResult.countTotal } }}</span><br/>
    <span *ngIf="jobResult.reportError">{{ 'msg.user.calculate-batch.result.resume-failed' | translate : { nbFailed: jobResult.countFailed, total: jobResult.countTotal } }}</span><br/>
    <span *ngIf="jobResult.reportError">{{ 'msg.user.calculate-batch.result.failure-detail' | translate }}</span><br/>
    <span *ngIf="jobResult.reportError" [innerHTML]="jobResult.reportError"></span>
  </ng-container>

  <ng-container *ngIf="!showResult()">
    <span [innerHTML]="getJobStep()"></span><br/>
    <mat-progress-bar *ngIf="showProgress()" [mode]="getProgressMode()" [value]="getProgressValue()"></mat-progress-bar>
  </ng-container>

  <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
    <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.ok' | translate}}" (click)="continue()"></button>
    <button pButton class="neq-primeng-button-text" label="{{'label.user.calculate-batch.cancel-button' | translate}}" *ngIf="!showResult()" (click)="cancel()"></button>
  </div>
</div>
